import React from 'react';
import { Column, Columns } from '../Elements/Layouts';
import StepsStatusBar from './StepsStatusBar';
import { ISteps } from 'core/redux/features/booking/types';

import './CheckoutContainer.scss';

interface IProps {
  title: string;
  activeStep: number;
  steps: ISteps;
  children: React.ReactNode;
  id?: string;
  loading?: boolean;
  hideStep?: boolean;
}

export default function CheckoutContainer({
  activeStep,
  steps,
  title,
  children,
  id,
  hideStep,
}: IProps) {
  return (
    <div className="checkout page-transition__content" id="checkout-page">
      <div className="container" id={id ?? ''}>
        <Columns gap={false} className="checkout__header">
          <Column className="checkout__title">
            <span className="">{title}</span>
          </Column>
          <Column className="">
            {!hideStep ? (
              <div className="checkout__steps">
                <StepsStatusBar steps={steps} activeStep={activeStep} />
              </div>
            ) : null}
          </Column>
        </Columns>
      </div>
      {children}
    </div>
  );
}

CheckoutContainer.defaultProps = {
  hideStep: false,
};
